import Http from './../http';

const prefix = '/domain';

export const connect = (params) => Http.authApi().post(`${prefix}/connect`, params);

export const disconnect = (params) => Http.authApi().post(`${prefix}/disconnect`, params);

export const config = (params) => Http.authApi().post(`${prefix}/config`, params);



// WEBPACK FOOTER //
// ./src/js/services/editor/domain.js